// Global toast instance - will be set by the ToastProvider
let globalToastAdd:
  | ((
      message: string,
      description?: string,
      type?: 'success' | 'error' | 'warning' | 'info',
      duration?: number,
      refreshAction?: { label: string; onRefresh: () => void }
    ) => void)
  | null = null;

export const setGlobalToastAdd = (
  addToast: (
    message: string,
    description?: string,
    type?: 'success' | 'error' | 'warning' | 'info',
    duration?: number,
    refreshAction?: { label: string; onRefresh: () => void }
  ) => void
) => {
  globalToastAdd = addToast;
};

export const toast = {
  error: (
    message: string,
    description?: string,
    refreshAction?: { label: string; onRefresh: () => void }
  ) => {
    if (globalToastAdd) {
      globalToastAdd(message, description, 'error', 5000, refreshAction);
    }
  },

  warning: (
    message: string,
    description?: string,
    refreshAction?: { label: string; onRefresh: () => void }
  ) => {
    if (globalToastAdd) {
      globalToastAdd(message, description, 'warning', 4000, refreshAction);
    }
  },

  info: (message: string, description?: string) => {
    if (globalToastAdd) {
      globalToastAdd(message, description, 'info', 3000);
    }
  },

  success: (message: string, description?: string) => {
    if (globalToastAdd) {
      globalToastAdd(message, description, 'success', 3000);
    }
  },
};
